export interface DownloadToolkitInfo {
	os: string;
}

export interface ContentItem {
	title: string;
	description: string;
	image: string | { file: File };
	image_url?: string;
}

export interface Phrase {
	content: string;
	color: string;
	scale: number;
	z_index?: number;
}

export class ToolkitData {
	hero_banner_toolkit: {
		headline: string;
		image: string;
	};
	how_to_use_section_toolkit: {
		name: string;
		headline: string;
		body: string;
		button: string;
		steps: ContentItem[];
	};
	objectives_section_toolkit: {
		name: string;
		headline: string;
		objectives: ContentItem[];
	};
	where_does_the_toolkit_fit_section_toolkit: {
		name: string;
		headline: string;
		body: string;
		phrases: Phrase[];
	};

	constructor(data: any = {}) {
		this.hero_banner_toolkit = data?.hero_banner_toolkit?.value;
		this.how_to_use_section_toolkit = data?.how_to_use_section_toolkit?.value;
		this.objectives_section_toolkit = data?.objectives_section_toolkit?.value;
		this.where_does_the_toolkit_fit_section_toolkit = data?.where_does_the_toolkit_fit_section_toolkit?.value;
	}
}
